import { useRef, useState } from "react";
import { Marker, NotificationMarker } from "../../../../../services/administrationService/types/administrationServiceTypes";
import { ReactComponent as ArrowDropUp } from "../../../../../icons/arrow_drop_up.svg";
import { ReactComponent as ArrowDropDown } from "../../../../../icons/arrow_drop_down.svg";
import './selectMarker.scss';
import { SelectMarkerProps } from "./types/selectMarkerProps";
import { useClickOutside } from "../../../../../hooks/clickOutsideHook";

const SelectMarker = (props: SelectMarkerProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const wrapperRef = useRef<HTMLDivElement>(null);
    useClickOutside(wrapperRef, () => {
        setIsOpen(false);
    });

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }

    const changeOnBlur = (event: any) => {
        event.target.value = "";
        setTimeout(() => { setIsOpen(false); }, 150);
    }

    const onHandleClick = (value: string) => {
        setIsOpen(false);
        if (props.onChange) props.onChange(value);
    }

    return (
        <div className="select-marker-div" ref={wrapperRef} >
            <div className="select-marker-dropdown body-txt-medium " onClick={toggleDropdown} onBlur={changeOnBlur}>{props.title}: {isOpen ? <ArrowDropUp onClick={toggleDropdown} /> : <ArrowDropDown onClick={toggleDropdown} />}</div>
            {isOpen && <div className="select-marker-items">{props.markers?.map((row: NotificationMarker) => {
                return <ul className="select-marker-ul" key={row.id}>
                    <li className="body-txt-large-bold select-marker-li-title">{row.name}</li>
                    {row.markers?.map((marker: Marker, index: number) => {
                        return <li className="body-txt-medium select-marker-li" key={index} onClick={() => { onHandleClick(`{${row.id}.${marker.value}}`) }}>
                            {marker.name}
                        </li>
                    })}
                </ul>
            })}
            </div>}
        </div>
    )
}

export default SelectMarker;
